<template>
  <j-modal
    :title="title"
    :width="width"
    :visible="visible"
    :confirmLoading="confirmLoading"
    switchFullscreen
    @ok="handleOk"
    @cancel="handleCancel"
    cancelText="关闭"
  >
    <a-spin :spinning="confirmLoading">
      <a-form :form="form">
        <a-form-item label="姓名" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input
            v-decorator="['realName']"
            placeholder="请输入姓名"
          ></a-input>
        </a-form-item>
        <a-form-item label="手机" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input v-decorator="['phone']" placeholder="请输入手机"></a-input>
        </a-form-item>
        <a-form-item
          label="证件号"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <a-input v-decorator="['idNo']" placeholder="请输入证件号"></a-input>
        </a-form-item>
        <a-form-item
          label="证件类型"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <a-select v-decorator="['idType']" placeholder="请选择证件类型">
            <a-select-option :value="0">身份证</a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item
          label="黑名单类型"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <a-select
            v-decorator="[
              'type',
              { rules: [{ required: true, message: '请选择黑名单类型' }] }
            ]"
            placeholder="请选择黑名单类型"
          >
            <a-select-option
              v-for="item in dictOptions"
              :key="parseInt(item.value)"
              :value="parseInt(item.value)"
              >{{ item.text }}</a-select-option
            >
          </a-select>
        </a-form-item>
      </a-form>
    </a-spin>
  </j-modal>
</template>

<script>
import { ajaxGetDictItems } from '@/api/api';
import { httpAction } from '@/api/manage';
import pick from 'lodash.pick';
import JDate from '@/components/jeecg/JDate';

export default {
  name: 'UserBlacklistModal',
  components: {
    JDate
  },
  data() {
    return {
      form: this.$form.createForm(this),
      title: '操作',
      width: 800,
      visible: false,
      model: {},
      labelCol: {
        xs: { span: 24 },
        sm: { span: 5 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 }
      },
      confirmLoading: false,
      validatorRules: {},
      url: {
        add: process.env.VUE_APP_CMS_CUSTOMER + '/user/blacklist/add',
        edit: process.env.VUE_APP_CMS_CUSTOMER + '/user/blacklist/edit'
      },
      dictOptions: []
    };
  },
  created() {
    ajaxGetDictItems('user_blacklist', null).then(res => {
      if (res.success) {
        this.dictOptions = res.result;
      }
    });
  },
  methods: {
    add() {
      this.edit({});
    },
    edit(record) {
      this.form.resetFields();
      this.model = Object.assign({}, record);
      this.visible = true;
      this.$nextTick(() => {
        this.form.setFieldsValue(
          pick(this.model, 'realName', 'phone', 'idNo', 'idType', 'type')
        );
      });
    },
    close() {
      this.$emit('close');
      this.visible = false;
    },
    handleOk() {
      const that = this;
      // 触发表单验证
      this.form.validateFields((err, values) => {
        if (!err) {
          that.confirmLoading = true;
          let httpurl = '';
          let method = '';
          if (!this.model.id) {
            httpurl += this.url.add;
            method = 'post';
          } else {
            httpurl += this.url.edit;
            method = 'post';
          }
          let formData = Object.assign(this.model, values);
          console.log('===', !formData.phone, formData);
          if (!formData.phone && !formData.idNo && !formData.idType) {
            this.$message.warn('手机号和证件必须二选一');
            that.confirmLoading = false;
            return;
          }
          httpAction(httpurl, formData, method)
            .then(res => {
              if (res.success) {
                that.$message.success(res.message);
                that.$emit('ok');
              } else {
                that.$message.warning(res.message);
              }
            })
            .finally(() => {
              that.confirmLoading = false;
              that.close();
            });
        }
      });
    },
    handleCancel() {
      this.close();
    },
    popupCallback(row) {
      this.form.setFieldsValue(
        pick(row, 'realName', 'phone', 'idNo', 'idType', 'type')
      );
    }
  }
};
</script>
